import React from 'react';
import PropTypes from 'prop-types';
import {
  ClipboardDocumentIcon,
  PhoneIcon,
  EnvelopeIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ConsultaCidTussDetailsModal = ({ visible, selectedItem, onClose }) => {
  if (!selectedItem) return null;

  const handleCopyToClipboard = () => {
    const textToCopy = `
      Código TUSS: ${selectedItem.id}
      Descrição: ${selectedItem.name || 'Sem descrição'}
      Fabricante: ${selectedItem.manufacturer || 'N/A'}
      Modelo: ${selectedItem.model || 'N/A'}
      Data de Início: ${selectedItem.startDate || 'N/A'}
    `;
    navigator.clipboard.writeText(textToCopy);
    toast.success('Informações copiadas para a área de transferência!');
  };

  const handleSendWhatsApp = () => {
    const message = `Código TUSS: ${selectedItem.id}%0ADescrição: ${selectedItem.name || 'Sem descrição'}%0AFabricante: ${selectedItem.manufacturer || 'N/A'}%0AModelo: ${selectedItem.model || 'N/A'}%0AData de Início: ${selectedItem.startDate || 'N/A'}`;
    const whatsappUrl = `https://wa.me/?text=${message}`;
    window.open(whatsappUrl, '_blank');
    toast.info('Redirecionando para o WhatsApp...');
  };

  const handleSendEmail = () => {
    const subject = `Informações do Código TUSS: ${selectedItem.id}`;
    const body = `
      Código TUSS: ${selectedItem.id}
      Descrição: ${selectedItem.name || 'Sem descrição'}
      Fabricante: ${selectedItem.manufacturer || 'N/A'}
      Modelo: ${selectedItem.model || 'N/A'}
      Data de Início: ${selectedItem.startDate || 'N/A'}
    `;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    toast.info('Abrindo o cliente de email...');
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center ${
        visible ? 'block' : 'hidden'
      }`}
    >
      <ToastContainer />
      <div
        className="fixed inset-0 rounded-3x1 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      ></div>

      <div className="relative bg-white rounded-lg shadow-xl w-full max-w-2xl p-8 transform transition-all">
        <div className="flex justify-between items-center border-b pb-3">
          <h3 className="text-lg font-semibold text-gray-800">
            Código: {selectedItem.id}
          </h3>
          <button
            onClick={onClose}
            className="text-white-500 hover:text-white-800"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
          <p className="text-sm text-gray-700">
            <strong>Código TUSS:</strong> {selectedItem.id}
          </p>
          <p className="text-sm text-gray-700">
            <strong>Descrição:</strong> {selectedItem.name || 'Sem informação'}
          </p>
          <p className="text-sm text-gray-700">
            <strong>Fabricante:</strong>{' '}
            {selectedItem.manufacturer || 'Sem informação'}
          </p>
          <p className="text-sm text-gray-700">
            <strong>Modelo:</strong> {selectedItem.model || 'Sem informação'}
          </p>
          <p className="text-sm text-gray-700">
            <strong>Data de Início:</strong>{' '}
            {selectedItem.startDate || 'Sem informação'}
          </p>
        </div>

        <div className="mt-6 flex justify-between">
          <button
            onClick={handleCopyToClipboard}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-3x1 hover:bg-blue-700 transition duration-200"
          >
            <ClipboardDocumentIcon className="h-5 w-5 mr-2" />
            Copiar
          </button>
          <button
            onClick={handleSendWhatsApp}
            className="flex items-center px-4 py-2 bg-green-600 text-white rounded-3x1 hover:bg-green-700 transition duration-200"
          >
            <PhoneIcon className="h-5 w-5 mr-2" />
            WhatsApp
          </button>
          <button
            onClick={handleSendEmail}
            className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-3x1 hover:bg-gray-700 transition duration-200"
          >
            <EnvelopeIcon className="h-5 w-5 mr-2" />
            Email
          </button>
        </div>
      </div>
    </div>
  );
};

ConsultaCidTussDetailsModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  selectedItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    manufacturer: PropTypes.string,
    model: PropTypes.string,
    startDate: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};

export default ConsultaCidTussDetailsModal;
